
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/moje-uslugi/reaktywacja/czas-minal",
      function () {
        return require("private-next-pages/moje-konto/moje-uslugi/reaktywacja/czas-minal.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/moje-uslugi/reaktywacja/czas-minal"])
      });
    }
  